// Wraps every leaf string in ⟦…⟧ so any un-extracted English in components is
// visually obvious when the app is run with the en-XA pseudo-locale. The brackets
// also help spot truncation / layout issues that English alone hides.
export function buildPseudoCatalog(source) {
    if (typeof source === 'string') {
        return `⟦${source}⟧`;
    }
    if (Array.isArray(source)) {
        return source.map(buildPseudoCatalog);
    }
    if (source && typeof source === 'object') {
        const result = {};
        for (const key of Object.keys(source)) {
            result[key] = buildPseudoCatalog(source[key]);
        }
        return result;
    }
    return source;
}
